import { useMutation } from "@tanstack/react-query";
import { remindMe } from "../../API/functions";
import { toast } from "react-toastify";

export const useRemindMe = () => {
  const { mutate ,isPending } = useMutation({
    mutationFn: (vars) => remindMe(vars),
    onSuccess: (data) => {
      toast.success(data.message);
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.message || "Something went wrong!";
      toast.error(errorMessage);
    },
  });

  return { mutate,isPending };
};
